import { MINUTE } from '@/utils/consts'
import dayjs from 'dayjs'
import { useCutOffDate } from './useCutOffDate'
import { useEffect, useState } from 'react'
import { useParsedQuery } from '@/hooks/useParsedQuery'
import { OutboundSchedulePageQueryParams } from '../types/query'

const IN_15_MIN_CUT_OFF_TIME = 15

/**
 *  현재로부터 15분 이내의 미래 시간대인지 체크 (지난 시간대는 false)
 *  - 1 minute interval 체크
 */
export const useIsIn15MinCutOff = ({ date, time }: { date: string; time: string }): boolean => {
  const { parsedQs } = useParsedQuery<OutboundSchedulePageQueryParams>()

  const { cutOffDate } = useCutOffDate()

  const [isIn15Min, setIsIn15Min] = useState(isIn15MinCutOff({ date, time }))

  useEffect(() => {
    const interval = setInterval(() => {
      setIsIn15Min(isIn15MinCutOff({ date, time }))
    }, MINUTE)

    return () => clearInterval(interval)
  }, [time, cutOffDate])

  useEffect(() => {
    setIsIn15Min(isIn15MinCutOff({ date, time }))
  }, [parsedQs.date])

  return isIn15Min
}

export const isIn15MinCutOff = ({ date, time }: { date: string; time: string }) => {
  const diffMin = dayjs(`${date} ${time}`).diff(dayjs(), 'minute')

  return diffMin >= 0 && diffMin <= IN_15_MIN_CUT_OFF_TIME
}
